import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { GenericNotification } from './GenericNotification';
import { useFormattedBytes } from '../../../utils/hooks/useFormattedBytes';
import { INotification } from '../../../utils/hooks/useNotificator/useNotificator.types';

export const deleteForeverWithStorageDeltaNotification = (storageDelta: number) => {
  const NotificationComponent: FC<{ notification: INotification }> = ({ notification }) => (
    <GenericNotification
      notification={notification}
      text={
        <FormattedMessage
          id="Storage.Media_Notification_Trash_Removed_Items"
          values={{ amount: useFormattedBytes(storageDelta) }}
        />
      }
    />
  );

  return NotificationComponent;
};
